import { Slider, makeStyles, withStyles } from '@material-ui/core';

import { colors } from '@chhjit/react-components';

export const CustomSlider = withStyles({
  root: {
    padding: 0,
    color: colors.primary.main,
    height: 4,
  },
  thumb: {
    height: 10,
    width: 10,
    backgroundColor: '#fff',
    border: `2px solid ${colors.primary.main}`,
    marginTop: -3,
    '&:focus, &:hover, &$active': {
      boxShadow: 'inherit',
    },
  },
  active: {},
  track: {
    height: 4,
    borderRadius: 5,
  },
  rail: {
    height: 4,
    borderRadius: 5,
    backgroundColor: colors.grey20,
  },
})(Slider);

export const useStyles = makeStyles(() => ({
  cropContainer: {
    position: 'relative',
    width: '100%',
    display: 'inline-block',
  },
  freeSpace: (props: { containerAspect: number }) => ({
    marginTop: `${(1 / props.containerAspect) * 100}%`,
  }),
  heightAvatarGreaterWidth: {
    '& img': {
      width: '100%',
      height: 'auto',
    },
  },
  dialogPaper: {
    maxWidth: '500px',
  },
  controls: {
    margin: '8px 16px',
  },
  cropSaveButton: {
    width: '70px',
  },
}));
